module.exports = __webpack_public_path__ + "static/the-secret-life-of-salvador-dalí-eae31978ca0e37a4daa52f5a7bbd3cdd.jpg";